export default () => ({
    popoverContent: {
        maxWidth: 280,
        padding: 4,
    },
    popoverItem: {
        display: 'block',
        marginTop: 4,
    },
    summaryChip: {
        maxWidth: '100%',
        flexShrink: 0,
    },
});
